import { PaymentElement as StripePaymentElement } from '@stripe/react-stripe-js';
import type {
  StripePaymentElementChangeEvent,
  StripePaymentElementOptions,
} from '@stripe/stripe-js';
import cx from 'classnames';
import { useState } from 'react';
import styles from './PaymentElement.scss';

const PAYMENT_ELEMENT_OPTIONS: StripePaymentElementOptions = {
  // fields: {
  //   billingDetails: {
  //     address: 'never', // confirm what we were setting as the zip code previously, and set that as the default value
  //   },
  // },
};
// const appearance = {
//   iconStyle: 'solid',
//   hidePostalCode: true,
//   style: {
//     base: {
//       color: '#000',
//       fontFamily: '-apple-system, BlinkMacSystemFont, Inter, sans-serif',
//       fontSize: '14px',
//       iconColor: '#364153',
//       '::placeholder': {
//         color: '#677489',
//       },
//     },
//     invalid: {
//       iconColor: '#b14a53',
//       color: '#b14a53',
//     },
//     complete: {
//       iconColor: '#84b14a',
//     },
//   },
// };

interface Props {
  onChange: (event: StripePaymentElementChangeEvent) => void;
  options?: StripePaymentElementOptions;
}

export const PaymentElement = ({ onChange, options }: Props) => {
  const [paymentElementtHasFocus, setPaymentElementtHasFocus] =
    useState<boolean>();

  const paymentElementtStyle = paymentElementtHasFocus
    ? cx(styles.paymentElement, styles.paymentElementFocused)
    : styles.paymentElement;

  return (
    <div className={paymentElementtStyle}>
      <StripePaymentElement
        options={{ ...PAYMENT_ELEMENT_OPTIONS, ...options }}
        onBlur={() => setPaymentElementtHasFocus(false)}
        onChange={onChange}
        onFocus={() => setPaymentElementtHasFocus(true)}
      />
    </div>
  );
};
